import { Col, Flex, Row, DatePicker } from "antd";
import CardComponent from "@/components/card";
import Container from "@/components/container/Container";
import BackWithLabel from "@/components/common/BackWithLabel";
import "@/styles/pages/guide/my-availability.scss";
import IconDropDown from "@/components/icons/IconDropDown";
import { useNavigate } from "react-router-dom";
import { DAYS } from "@/helpers";
import ButtonComponent from "@/components/button/Button";
import {
  updateUserAvailability,
  updateUserUnavailability,
} from "@/services/users/updateUserAvailability";
import { useDispatch } from "react-redux";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useEffect, useRef, useState } from "react";
import { getUserUnavailability } from "@/services/users/getUserAvailability";
import dayjs from "dayjs";
import { updateGuideProfileAvailability } from "@/services/users/updateUserProfile";
import { getGuideProfile } from "@/services/guides/getGuideProfile";
import {
  convertTimeRangesToUTC,
  convertUTCDatesToLocal,
  transformTimeSlotsByDate,
} from "@/services/luxon";

const MyAvailibilty = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [unavailableDates, setUnavailableDates] = useState([]);
  const [previousUnavailableSlots, setPreviousUnavailableSlots] = useState([]);
  const [isGuideAvailable, setIsGuideAvailable] = useState(true);

  const handleAvailiblity = (d) => {
    navigate(`/availability/${d}`);
  };

  const handleResetAll = () => {
    dispatch(setCurrentForm("confirmDelete"));
    dispatch(setModalOpen(true));
    dispatch(
      setFormProps({
        onSubmit: () => {
          updateUserAvailability({
            days: DAYS.map((x) => x.value),
            timeslots: [],
          }).then((res) => {
            console.log(res);
            dispatch(setCurrentForm("successModal"));
            dispatch(
              setFormProps({
                message: "All Schedule reset successfully.",
                onSubmit: () => {
                  console.log("first");
                  dispatch(setModalOpen(false));
                },
              })
            );
          });
        },
        message: "Are you sure you want to reset all schedule?",
      })
    );
  };

  const handleDisableAll = (isGuideAvailable) => {
    dispatch(setCurrentForm("confirmDelete"));
    dispatch(setModalOpen(true));
    dispatch(
      setFormProps({
        onSubmit: () => {
          updateGuideProfileAvailability(!isGuideAvailable).then((res) => {
            console.log(res);
            setIsGuideAvailable(!isGuideAvailable);
            dispatch(setCurrentForm("successModal"));
            dispatch(
              setFormProps({
                message: isGuideAvailable
                  ? "your availability has been disabled."
                  : "your availability has been enabled.",
                onSubmit: () => {
                  console.log("first");
                  dispatch(setModalOpen(false));
                },
              })
            );
          });
        },
        message: isGuideAvailable
          ? "Are you sure you want to disable your availability?"
          : "Are you sure you want to enable your availability?",
      })
    );
  };

  const groupAndMergeTimeRangesByDate = (data) => {
    // Extract, flatten, and group by date
    const groupedByDate = data
      .flatMap((obj) => Object.values(obj).flat()) // Extract and flatten all values
      .reduce((acc, { date, start, end }) => {
        // Group by date
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push({ start, end });
        return acc;
      }, {});

    // Function to merge time ranges for a single date
    const mergeTimeRanges = (timeRanges) => {
      if (!timeRanges.length) return [];

      // Sort by start time
      timeRanges.sort((a, b) => a.start.localeCompare(b.start));

      let merged = [timeRanges[0]];

      for (let i = 1; i < timeRanges.length; i++) {
        let last = merged[merged.length - 1];
        let current = timeRanges[i];

        if (last.end === current.start) {
          // If timeslots are continuous
          last.end = current.end; // Merge
        } else {
          merged.push(current);
        }
      }

      return merged;
    };

    // Apply merging for each date
    Object.keys(groupedByDate).forEach((date) => {
      groupedByDate[date] = mergeTimeRanges(groupedByDate[date]);
    });

    return groupedByDate;
  };

  const onUnavailableDatesSelected = (dates, dateString) => {
    const selectedDates = dateString;
    console.log("Selected Dates:", selectedDates);
    const existingDates = unavailableDates.map((date) => date.format("YYYY-MM-DD"));

    const datesToRemove = existingDates.filter((date) => !selectedDates.includes(date));

    const datesToAdd = selectedDates.filter((date) => !existingDates.includes(date));
    console.log("Previous Unavailables:", previousUnavailableSlots);
    if (datesToRemove.length > 0) {
      const datesToRemoveUTC = [];
      for (let i = 0; i < datesToRemove.length; i++) {
        const convertedDate = convertTimeRangesToUTC(datesToRemove[i], [
          { start: "00:00", end: "24:00" },
        ]);
        datesToRemoveUTC.push(convertedDate);
      }
      const removePayload = transformTimeSlotsByDate(
        groupAndMergeTimeRangesByDate(datesToRemoveUTC)
      );
      console.log("Remove Payload in UTC:", removePayload);
      updateUserUnavailability(removePayload, "remove").then((res) => {
        console.log("Remove Response:", res);
        fetchUserUnavailabilityDates();
      });
    }

    if (datesToAdd.length > 0) {
      const datesToAddUTC = [];
      for (let i = 0; i < datesToAdd.length; i++) {
        const convertedDate = convertTimeRangesToUTC(datesToAdd[i], [
          { start: "00:00", end: "24:00" },
        ]);
        datesToAddUTC.push(convertedDate);
      }
      const addPayload = transformTimeSlotsByDate(groupAndMergeTimeRangesByDate(datesToAddUTC));
      console.log("Add Payload in UTC:", addPayload);
      updateUserUnavailability(addPayload, "add").then((res) => {
        console.log("Add Response:", res);
        fetchUserUnavailabilityDates();
      });
    }
  };
  const onDatePickerClose = () => {
    console.log("Date Picker Closed");
  };

  const datePickerRef = useRef(null);

  // const openDatePicker = () => {
  //     if (datePickerRef.current) {
  //       const inputElement =
  //         datePickerRef.current.querySelector("input");
  //       if (inputElement) {
  //         inputElement.click(); // Open the DatePicker by simulating a click
  //       }
  //     } // Opens the DatePicker programmatically
  // };

  const openDatePicker = () => {
    if (datePickerRef.current?.nativeElement) {
      const inputElement = datePickerRef.current.nativeElement.querySelector("input");
      if (inputElement) {
        inputElement.click(); // Open the DatePicker by simulating a click
      }
    }
  };
  async function fetchUserUnavailabilityDates() {
    getUserUnavailability().then((res) => {
      setPreviousUnavailableSlots(res);
      const UTCtoLocal = convertUTCDatesToLocal(res);
      console.log("Previous Unavailables:", UTCtoLocal);
      const datesArray = Object.keys(UTCtoLocal).map((date) => dayjs(date));

      setUnavailableDates([...datesArray]);
      console.log(datesArray);
    });
  }

  async function fetchGudieProfileAvailability() {
    getGuideProfile().then((res) => {
      console.log(res);
      if (res) {
        const { isAvailable } = res;
        setIsGuideAvailable(isAvailable);
      }
    });
  }

  useEffect(() => {
    fetchUserUnavailabilityDates();
    fetchGudieProfileAvailability();
  }, []);

  return (
    <div className="guide-availibilty-wrapper">
      <Container>
        <CardComponent>
          <Row justify={"space-between"}>
            <Col xxl={24}>
              <div className="heading">
                <BackWithLabel label={"My availability"} path="/dashboard" />
              </div>
            </Col>
            <Flex
              gap={"5px"}
              style={{
                flexWrap: "wrap",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <ButtonComponent
                label={isGuideAvailable ? "Disable All" : "Enable All"}
                size="medium"
                onClick={() => handleDisableAll(isGuideAvailable)}
              />
              <ButtonComponent
                label="Reset All"
                size="medium"
                disabled={!isGuideAvailable}
                onClick={handleResetAll}
              />
              <ButtonComponent
                label="Update Unavailability"
                size="medium"
                disabled={!isGuideAvailable}
                onClick={openDatePicker}
              >
                <DatePicker
                  ref={datePickerRef}
                  multiple
                  onChange={onUnavailableDatesSelected}
                  onOpenChange={onDatePickerClose}
                  maxTagCount="responsive"
                  size="small"
                  value={unavailableDates}
                  disabledDate={
                    (current) => current && current < dayjs().startOf("month") // Only disable past dates
                  }
                  style={{
                    visibility: "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                />
                {/* <DatePicker
                ref={datePickerRef}
                  selected={unavailableDates}
                  v-model="unavailableDates" 
                  onChange={onUnavailableDatesSelected}
                  onClose={onDatePickerClose}
                  multiple
                  sort
                  format={"DD/MM/YYYY"}
                  calendarPosition="bottom-center"
                  className="custom-date-picker"
                  placeholder="Select Dates"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                  /> */}
              </ButtonComponent>
              {/* <ButtonComponent
                label="Update Unavailability"
                size="medium"
                onClick={() => {
                  dispatch(setCurrentForm("updateUnavailability"));
                  dispatch(setModalOpen(true));
                }}
                /> */}

              {/* <DatePicker multiple onChange={onUnavailableDatesSelected} maxTagCount="responsive" size="small" needConfirm style={{width: "150px"}} /> */}
            </Flex>
          </Row>
          <Row gutter={[16, 24]}>
            {DAYS.map((d) => {
              return (
                <Col
                  key={d.value}
                  xxl={8}
                  xl={8}
                  lg={8}
                  md={12}
                  sm={24}
                  xs={24}
                  onClick={() => handleAvailiblity(d.value)}
                  style={{
                    paddingTop: "10px",
                    pointerEvents: isGuideAvailable ? "auto" : "none",
                    opacity: isGuideAvailable ? 1 : 0.6,
                  }}
                >
                  <CardComponent className="day-chip">
                    <Flex justify="space-between" align="center">
                      <span className="body-b12">{d.label}</span>
                      <IconDropDown className="cursor-pointer" />
                    </Flex>
                  </CardComponent>
                </Col>
              );
            })}
          </Row>
        </CardComponent>
      </Container>
    </div>
  );
};

export default MyAvailibilty;
